import React from "react";
import { Upper } from "./ProductPageDetails/Upper";
import { Left } from "./ProductPageDetails/Left";
import { Right } from "./ProductPageDetails/Right";


export const ProductPageCard = ({data}) => {

  return (
    <div className="max-w-7xl mx-auto py-10">
      <Upper data={data} />
      <div className="flex flex-col lg:flex-row lg:space-x-6 py-8">
        <Left data={data} />
        <Right data={data} />
      </div>
    </div>
  );
};
